// the timeout delay to stop the scroll event tracking
export const SCROLL_DELAY = 300;
